import Vue from 'vue'

import store from '@/store'

const state = {
  demande: {
    infosFournisseur: {
      informationEnlevement: [],
      informationsAdminstratives: []
    },
    tauxDevise: null,
    termeAchat: null,
    listeProduits: []
  },
  infosSupplementaire: {
    commentaire: null,
    nomContactDemande: null
  }
}

const getters = {
  // Acces via  this.$store.getters.demande
  demande(state) {
    return state.demande
  },

  infosSupplementaire(state) {
    return state.infosSupplementaire
  }
}

const actions = {
  // Demande
  initialiserDemande({ commit }) {
    commit('initialiserDemande')
  },
  initialiserInfosSupplementaire({ commit }) {
    commit('initialiserInfosSupplementaire')
  }
}

const mutations = {
  // Demande
  initialiserDemande(state) {
    state.demande = {}
  },

  initialiserInfosSupplementaire(state) {
    state.infosSupplementaire = {
      commentaire: null,
      nomContactDemande: null
    }
  }
}

// -------
// Helpers
// -------

export default {
  state,
  mutations,
  getters,
  actions
}
